import { Buffer } from 'buffer';

const LINK_VERSION = 'v1';

export const LINK_TYPES = {
    PROCEDURE: 'procedure'
};

export const createEnlaceUrl = (type, id) => {
    const payload = {
        t: type,
        id: id
    };
    
    const jsonPayload = JSON.stringify(payload);
    const base64Payload = Buffer.from(jsonPayload, 'utf8').toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
    
    const versionedPayload = `${LINK_VERSION}.${base64Payload}`;
    const origin = window.location.origin;
    
    return `${origin}/enlaces/${versionedPayload}`;
};

export const parseEnlacePayload = (payload) => {
    if (!payload || typeof payload !== 'string') {
        return null;
    }
    
    const parts = payload.split('.');
    if (parts.length !== 2) {
        return null;
    }
    
    const [version, base64Data] = parts;
    
    if (version !== LINK_VERSION) {
        return null;
    }
    
    try {
        const base64Url = base64Data
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        
        const padded = base64Url + '='.repeat((4 - base64Url.length % 4) % 4);
        const jsonPayload = Buffer.from(padded, 'base64').toString('utf8');
        const parsed = JSON.parse(jsonPayload);
        
        if (!parsed.t || !parsed.id) {
            return null;
        }
        
        return {
            type: parsed.t,
            id: parsed.id
        };
    } catch (error) {
        return null;
    }
};

export const getRedirectUrl = (type, id) => {
    switch (type) {
        case LINK_TYPES.PROCEDURE:
            return `/procedimiento/${id}`;
        default:
            return '/procedimientos';
    }
};
